import React from 'react'
import { Box, Flex, Text } from 'pcln-design-system'
import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components'
import { WebPBackgroundImage } from '@pcln/content-tile'

const keyframesObj = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  51% { opacity: 0; }
  100% { opacity: 0; }
`

const FlexWrapper = styled(Flex)`
  position: relative;
  height: 100%;
`
const BannerA = styled(Text)`
  animation: ${keyframesObj} 8s infinite;
`

const BannerB = styled(Flex)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  animation: ${keyframesObj} 8s 4s infinite;
`
const StyledBox = styled(Box)`
  display: inline-block;
`

const RotatingText = props => (
  <FlexWrapper flexdirection='column' justifyContent='center' alignItems='center'>
    <BannerA color='primary'>
      {props.rotatingBannerA}
      <sup>*</sup>
    </BannerA>
    <BannerB color='background.light' justifyContent='center' alignItems='center' s>
      <Text color='primary'>
        {props.rotatingBannerB}
      </Text>
      {props.isImageIncluded && (
        <StyledBox width='310px' mx={3}>
          <WebPBackgroundImage
            image={props.image}
            imageWebP={props.imageWebP}
            height={props.height}
            style={{
              backgroundColor: `${props.imageBackgroundColor}`,
              backgroundSize: 'contain'
            }}
          />
        </StyledBox>
      )}
    </BannerB>
  </FlexWrapper>
)

RotatingText.displayName = 'RotatingText'

RotatingText.propTypes = {
  rotatingBannerA: PropTypes.string.isRequired,
  rotatingBannerB: PropTypes.string.isRequired,
  isImageIncluded: PropTypes.bool,
  image: PropTypes.string,
  imageWebP: PropTypes.string,
  height: PropTypes.string,
  imageBackgroundColor: PropTypes.string
}

export default RotatingText
